// CSS Modules - component class name prefix: SidebarSlider__

<template>
  <div :class="$style.container">
    <agile
      :dots="checkSlidesCount"
      :navButtons="false"
      :fade="true"
      :speed="500"
      :autoplay="true"
      :autoplaySpeed="7000"
    >
      <figure
        :class="[
          $style.slide,
          { [$style.slideStandalone]: slides.length === 1 }
        ]"
        v-for="(slide, index) in slides"
        :key="index"
      >
        <template v-if="slide.extendedSlider">
          <span
            :class="{
              [$style.videoLink]: slide.video,
              [$style.extended]: slide.extendedSlider
            }"
          >
            <div :class="{ [$style.productimage]: slide.isProduct }">
              <a :href="slide.link">
                <i v-if="slide.video" class="fab fa-youtube"></i>
                <img v-if="slide.video" :src="slide.image" :alt="slide.alt" />
                <ImageMagnifier
                  v-else
                  :alt="slide.alt"
                  :src="slide.image"
                  :zoom-src="slide.imageZoom || slide.image"
                  width="100%"
                  height="auto"
                  maskBgColor="#434140"
                  mask-height="70"
                  mask-width="70"
                  :scale="5"
                  :orientation="zoomOrientation"
                />
              </a>
            </div>
            <figcaption :class="$style.caption">
              <a
                v-if="slide.category"
                :href="slide.category.link"
                :class="$style.category"
              >
                {{ slide.category.title }}
              </a>
              <a
                :href="slide.link"
                :class="{ [$style.single]: checkSlidesCount === false }"
              >
                <div :class="$style.title">{{ slide.title }}</div>
                <p v-if="slide.text">{{ slide.text }}</p>
                <p v-if="slide.location">
                  <Flag
                    :flag="slide.location.flag"
                    size="xs"
                    :class="$style.flag"
                  />
                  <span>{{ slide.location.city }}</span>
                </p>
              </a>
            </figcaption>
          </span>
        </template>
        <template v-else>
          <a
            :class="{ [$style.videoLink]: slide.video }"
            @click="openModal(slide)"
          >
            <div :class="{ [$style.productimage]: slide.isProduct }">
              <i v-if="slide.video" class="fab fa-youtube"></i>
              <img v-if="slide.video" :src="slide.image" :alt="slide.alt" />
              <ImageMagnifier
                v-else
                :alt="slide.alt"
                :src="slide.image"
                :zoom-src="slide.imageZoom || slide.image"
                maskBgColor="#fff"
                width="100%"
                height="auto"
                mask-height="70"
                mask-width="70"
                :scale="5"
                :orientation="zoomOrientation"
              />
            </div>
            <figcaption
              :class="$style.caption"
              v-if="slide.title || slide.text"
            >
              <div :class="$style.title">
                {{ slide.title }}
              </div>
              <p v-if="slide.text">{{ slide.text }}</p>
            </figcaption>
          </a>
        </template>
      </figure>
      <template slot="prevButton"
        ><ChevronLeft
      /></template>
      <template slot="nextButton"
        ><ChevronRight
      /></template>
    </agile>
    <Modal
      :isModalOpen="isModalOpen"
      :isVideo="isVideo"
      :isProduct="isProduct"
      @closeModal="closeModal"
    >
      <iframe
        v-if="isVideo"
        :data-src="currentSlideSrc"
        frameborder="0"
        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <img v-else :src="currentSlideSrc" alt="" />
    </Modal>
  </div>
</template>

<script>
import { VueAgile } from "../vue-agile";
import Modal from "../Modal/Modal.vue";
import ChevronLeft from "../../assets/svg/ChevronLeft.vue";
import ChevronRight from "../../assets/svg/ChevronRight.vue";
import ImageMagnifier from "../ImageMagnifier/ImageMagnifier";
import Flag from "../Flag/Flag";
import v4 from "uuid/v4";
import { mergeSwitchWtParams } from "../../utils/tracking";

export default {
  name: "SidebarSlider",
  components: {
    agile: VueAgile,
    Modal,
    ChevronLeft,
    ChevronRight,
    Flag,
    ImageMagnifier
  },
  props: {
    slides: {
      type: Array,
      default: () => []
    },
    zoomOrientation: {
      type: String,
      default: () => "left"
    },
    wtParams: Object
  },
  data() {
    return {
      isModalOpen: false,
      isVideo: false,
      isProduct: false,
      currentSlideSrc: null,
      uuid: v4(),
      wtTrack: window.wtTrack
    };
  },
  computed: {
    checkSlidesCount() {
      return this.slides.length > 1;
    }
  },
  methods: {
    mergeWtParams(globalWtParams, itemWtParams, itemParams) {
      return mergeSwitchWtParams(globalWtParams, itemWtParams, itemParams);
    },
    openModal(slide) {
      this.isProduct = slide.isProduct || false;
      if (slide.video) {
        this.isVideo = true;
        this.currentSlideSrc = slide.video;
        slide.wtParams &&
          this.wtTrack(
            { cat: slide.wtParams.doctype },
            this.mergeWtParams(
              this.wtParams,
              {
                ...slide.wtParams,
                filename: slide.video
              },
              {}
            )
          );
      } else {
        this.currentSlideSrc = slide.imageZoom || slide.image;
      }
      this.isModalOpen = true;
    },
    closeModal() {
      this.isModalOpen = false;
      this.currentSlideSrc = null;
      this.isVideo = false;
    }
  }
};
</script>

<style module lang="scss">
@import "./SidebarSlider.scss";
</style>
